// import * as types from './action-types';
// import { PanelProxy } from '../../../proxies';

export default {}



// WEBPACK FOOTER //
// ./src/store/modules/settings/actions.js